import React, { useState } from 'react';
import { GiPlainSquare } from 'react-icons/gi';
import { FaPlus, FaMinus } from 'react-icons/fa';
import watermark from '../../Assets/water-mark.png'
import { MdArrowOutward } from 'react-icons/md';
import part from '../../Assets/mpart-2.png';
import part1 from '../../Assets/mpart-1.png';
import { useNavigate } from 'react-router-dom';

const accordionData = [
  {
    id: 1,
    title: "Meet and Consultant",
    content:
      "Of course. We are more than happy to visit your property at a time convenient for yourself and quote for the required works. If you don’t own the property and are looking for us to quote on work. Aenean commodo nec ligula eget dolor.",
  },
  {
    id: 2,
    title: "Planning and Design",
    content:
      "We collaborate closely with you to develop a design that fits your vision, budget, and requirements, ensuring optimal functionality and aesthetics.",
  },
  {
    id: 3,
    title: "Proceed with Construction",
    content:
      "Once the design is finalized and approved, we begin construction with a well-planned approach to ensure efficiency, safety, and quality.",
  },
  {
    id: 4,
    title: "Project Handover",
    content:
      "Upon completion, we conduct a final walkthrough to ensure everything meets your expectations before officially handing over the project.",
  }, 
];

const Acorden = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const navigate = useNavigate()

  return (
    <div className='max-w-screen-2xl mx-auto md:h-[450px] h-auto  relative'>
         <img src={part1} alt="part" className=' absolute  right-0 md:right-44 -top-12 w-44 md:h-[300px] h-24 object-contain' />

         <img src={part} alt="part" className='  md:flex hidden  absolute right-0 -top-12 w-24 md:w-36 h-44 md:h-[498px]' />
      <div className='md:flex   flex-none max-w-screen-xl mx-auto mt-12'>
        {/* Left Section */}
        <div className='md:w-[40%] w-full space-y-4 mt-7'>
          <span className="flex  justify-start space-x-2 md:ml-0 ml-6 ">
              <GiPlainSquare className="text-[#068b07] pt-1 " size={16} />
            <p className="text-gray-500  md:p-0 p-2 font-medium pt-1 text-sm">FULL PROJECT MANAGEMENT</p>
          </span>
          <h1 className='md:text-4xl text-xl  md:ml-0 ml-6 font-semibold'>How We Work Together?</h1>
          <p className='text-sm md:p-0 p-2 text-gray-700'>
            We celebrate the opportunity each project brings and leverage our 30+ years of
            experience to deliver customized construction solutions. Flexibility is essential
            in today’s world, and every project is unique.
          </p>
              <div className=' flex md:justify-start  justify-center'>
                        <button className="flex   gap-4 bg-[#068b07] text-white font-medium px-4 py-3" onClick={() => navigate('/contact')}>
                        <span className="pt-1 capitalize"> consultation & quote</span>
                            <MdArrowOutward className="bg-[#121315] text-white p-1" size={32} />
                          </button>
                        </div>
        </div>

        {/* Right Section - Accordion */}
        <div className='md:w-[40%] w-full space-y-4 p-4'>
          {accordionData.map((item, index) => (
            <div key={item.id} className={`border text-white border-gray-300 ${openIndex=== index ? '' : 'bg-[#1e2023] py-1.5 p-1 '}  `}>
              
              {/* Accordion Header */}
              <div>
                
              </div>
              <div 
                className={`flex justify-between items-center  cursor-pointer ${openIndex === index ? 'bg-[#068b07]  relative py-1.5 p-1   ' : ''}`} 
                onClick={() => toggleAccordion(index)}
              >
                {openIndex=== index?(
                    <img src={watermark} alt="watermark"  className=' absolute'/>
                ):(
                    <></>
                )}
                
                <h2 className={`text-lg pl-4 font-medium ${openIndex === index ? 'text-white' : ''}`}>
                   0{item.id}. {item.title}
                </h2>
                {openIndex === index ? (
                  <FaMinus className="text-white border bg-[#1e2023]  border-[#1e2023]   p-2" size={34} />
                ) : (
                  <FaPlus className="text-white border bg-[#404144]  border-[#404144]  p-2" size={34} />
                )}
              </div>

              {/* Accordion Content */} 
              {openIndex === index && (
                <p className="mt-2 p-2 text-sm text-gray-600">{item.content}</p>
              )}

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Acorden;
    